import { Page } from './types'
import Source from '../components/Source'

type ConfigureClusterManagerProps = { 
    isContainer: boolean
}

const render = ({ isContainer }: ConfigureClusterManagerProps) => {
    return <>
        <p>There are various parameters for the Cluster Manager. The easiest way to set these, is&nbsp;
            {isContainer ? <>by creating a <code>grb_rsm.cnf</code> configuration file</> : 
            <>by customizing the <code>grb_rsm.cnf</code> file included in the <code>bin</code> folder of the Gurobi Remote Services installation folder</>}.
            Each line in this file has the format <code>KEY=VALUE</code>. The settings below are the most commonly used.</p>
        <ul>
            <li><code>DB_URI</code> is the connection string to the database</li>
            <li><code>PORT</code> is the port where your application code (the "client") can reach the Cluster Manager (defaults to 61080).</li>
        </ul>
        <Source href="https://www.gurobi.com/documentation/{version}/remoteservices/configuring_the_cluster_ma.html"/>
    </>
}


const ConfigureClusterManager : Page<ConfigureClusterManagerProps> = { key: 'configure-cluster-manager', title: 'Configuring Cluster Manager', render }

export default ConfigureClusterManager